import { HeadedContainer } from "features/CenterContent/VehicleDetails/shared/HeadedContainer";
import { Box, BoxProps, HStack, VStack } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";
import styled, { RuleSet } from "styled-components";
import React, { ReactNode } from "react";
import { VariantColor } from "shared/utils/colorUtils";

const Header = styled(VStack)<{
  $panelStyle: RuleSet<object>;
}>`
  ${({ $panelStyle }) => $panelStyle};
  border-bottom: none; /* Since a DashedLine follow after */
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`;

const WidgetHeader = styled.div`
  padding-bottom: 6px;
  width: 100%;
`;

const WidgetHeaderText = styled.div`
  font-size: 21px;
  font-weight: bold;

  * {
    font-size: 21px !important;
    font-weight: bold !important;
  }
`;
/**
 * HeadedContainer, but its header is sticky. Use mock data and look at <TrainDetails/> to see its usage.
 * HeadedContainerSticky must be placed in a StickyController
 */

type HeadedContainerProps = {
  headingLeft?: ReactNode;
  panelStyle: RuleSet<object>; // aka css`xxx`
  variant: VariantColor;
  headerHeight?: string;
  headerAlignment?: "flex-start" | "center" | "flex-end";
  headingRight?: ReactNode;
  itemsLeft?: ReactNode;
  itemsRight?: ReactNode;
  children?: ReactNode;
} & BoxProps;

export const SimpleHeadedContainerSticky: FCWC<HeadedContainerProps> = ({
  panelStyle,
  headingLeft,
  headingRight,
  headerHeight,
  variant,
  children,
  ...props
}) => (
  <>
    <Box className="simple-sticky-container">
      <Header
        $panelStyle={panelStyle}
        minH={headerHeight}
        maxH={headerHeight}
        justifyContent="center"
      >
        <WidgetHeader>
          <HStack justify="space-between" width="100%">
            <WidgetHeaderText>{headingLeft}</WidgetHeaderText>
            <HStack justify="flex-end">{headingRight}</HStack>
          </HStack>
        </WidgetHeader>
      </Header>
    </Box>
    <HeadedContainer
      panelStyle={panelStyle}
      header={headingLeft}
      headerHeight={headerHeight}
      variant={variant}
      {...props}
    >
      {children}
    </HeadedContainer>
  </>
);
